import script from "./TrackItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrackItem.vue?vue&type=script&setup=true&lang=ts"

import "./TrackItem.vue?vue&type=style&index=0&id=51d1d8d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d1d8d4"]])

export default __exports__